import { render, staticRenderFns } from "./points-order.vue?vue&type=template&id=5cc0f395&"
import script from "./points-order.vue?vue&type=script&lang=js&"
export * from "./points-order.vue?vue&type=script&lang=js&"
import style0 from "./points-order.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports